import { Injectable } from '@angular/core';


@Injectable()
export class Session {
 

  constructor() {}


  hp(permission){
      if (localStorage.getItem("permissions")) {
        return localStorage.getItem("permissions").split(",").includes(permission);
      } else {
        return false;
      }
  }

  isClient(){
      return localStorage.getItem('profile')==='Cliente';
  }

}